// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { SignUpAuthSignupPostData, SignUpAuthSignupPostResponse, VerifyEmailAuthVerifyEmailPostData, VerifyEmailAuthVerifyEmailPostResponse, SignInAuthLoginPostData, SignInAuthLoginPostResponse, LogoutAuthLogoutPostResponse, RefreshTokenAuthRefreshPostResponse, CreateUserAdminUserPostData, CreateUserAdminUserPostResponse, UpdatePasswordAdminUsersUserIdPasswordPatchData, UpdatePasswordAdminUsersUserIdPasswordPatchResponse, UpdateUserAdminUserUserIdPatchData, UpdateUserAdminUserUserIdPatchResponse, DeleteUserAdminUserUserIdDeleteData, DeleteUserAdminUserUserIdDeleteResponse, ListUsersAdminUsersGetData, ListUsersAdminUsersGetResponse, GetUserAdminUsersUserIdGetData, GetUserAdminUsersUserIdGetResponse, RestoreUserAdminUsersUserIdRestorePostData, RestoreUserAdminUsersUserIdRestorePostResponse, PermanentlyDeleteUserAdminUsersUserIdPermanentDeleteData, PermanentlyDeleteUserAdminUsersUserIdPermanentDeleteResponse, CreateCompanyAdminCompanyPostData, CreateCompanyAdminCompanyPostResponse, GetCompanyAdminCompanyCompanyIdGetData, GetCompanyAdminCompanyCompanyIdGetResponse, UpdateCompanyAdminCompanyCompanyIdPutData, UpdateCompanyAdminCompanyCompanyIdPutResponse, GetMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGetData, GetMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGetResponse, GetReportByAdminAdminReportReportIdGetData, GetReportByAdminAdminReportReportIdGetResponse, AdminUpdateReportAdminReportReportIdPutData, AdminUpdateReportAdminReportReportIdPutResponse, AdminDeleteReportAdminReportReportIdDeleteData, AdminDeleteReportAdminReportReportIdDeleteResponse, ToggleReportStatusAdminReportReportIdStatusPatchData, ToggleReportStatusAdminReportReportIdStatusPatchResponse, ToggleSalesStatusAdminReportReportIdSalesStatusPatchData, ToggleSalesStatusAdminReportReportIdSalesStatusPatchResponse, RestoreReportAdminReportReportIdRestorePostData, RestoreReportAdminReportReportIdRestorePostResponse, PermanentlyDeleteReportAdminReportReportIdPermanentDeleteData, PermanentlyDeleteReportAdminReportReportIdPermanentDeleteResponse, DownloadExcelAdminReportIdExcelDownloadGetData, DownloadExcelAdminReportIdExcelDownloadGetResponse, DownloadPdfAdminReportIdPdfDownloadGetData, DownloadPdfAdminReportIdPdfDownloadGetResponse, RegenerateReportPdfAdminReportReportIdRegeneratePdfPostData, RegenerateReportPdfAdminReportReportIdRegeneratePdfPostResponse, DownloadReportPdfFromS3AdminReportReportIdPdfDownloadS3GetData, DownloadReportPdfFromS3AdminReportReportIdPdfDownloadS3GetResponse, DownloadOrderPdfFromS3AdminOrderOrderIdPdfDownloadS3GetData, DownloadOrderPdfFromS3AdminOrderOrderIdPdfDownloadS3GetResponse, GetMinimalOrdersAdminOrdersMinimalGetData, GetMinimalOrdersAdminOrdersMinimalGetResponse, AdminDeleteOrderAdminOrdersOrderIdDeleteData, AdminDeleteOrderAdminOrdersOrderIdDeleteResponse, UpdateOrderAdminOrdersOrderIdPutData, UpdateOrderAdminOrdersOrderIdPutResponse, RestoreOrderAdminOrdersOrderIdRestorePostData, RestoreOrderAdminOrdersOrderIdRestorePostResponse, PermanentlyDeleteOrderAdminOrdersOrderIdPermanentDeleteData, PermanentlyDeleteOrderAdminOrdersOrderIdPermanentDeleteResponse, GetOrderByIdAdminOrderOrderIdGetData, GetOrderByIdAdminOrderOrderIdGetResponse, DownloadOrderExcelAdminOrderIdExcelDownloadGetData, DownloadOrderExcelAdminOrderIdExcelDownloadGetResponse, DownloadPdfAdminOrderIdPdfDownloadGetData, DownloadPdfAdminOrderIdPdfDownloadGetResponse, DownloadMultipleReportsImagesAdminReportsImagesDownloadGetData, DownloadMultipleReportsImagesAdminReportsImagesDownloadGetResponse, DownloadMultipleOrdersImagesAdminOrdersImagesDownloadGetData, DownloadMultipleOrdersImagesAdminOrdersImagesDownloadGetResponse, CreateSalesPersonAdminSalesPersonsPostData, CreateSalesPersonAdminSalesPersonsPostResponse, ListSalesPersonsAdminSalesPersonsGetData, ListSalesPersonsAdminSalesPersonsGetResponse, GetSalesPersonAdminSalesPersonsSalesPersonIdGetData, GetSalesPersonAdminSalesPersonsSalesPersonIdGetResponse, UpdateSalesPersonAdminSalesPersonsSalesPersonIdPatchData, UpdateSalesPersonAdminSalesPersonsSalesPersonIdPatchResponse, DeleteSalesPersonAdminSalesPersonsSalesPersonIdDeleteData, DeleteSalesPersonAdminSalesPersonsSalesPersonIdDeleteResponse, CreateWorkTypeAdminWorkTypesPostData, CreateWorkTypeAdminWorkTypesPostResponse, ListWorkTypesAdminWorkTypesGetData, ListWorkTypesAdminWorkTypesGetResponse, GetWorkTypeAdminWorkTypesWorkTypeIdGetData, GetWorkTypeAdminWorkTypesWorkTypeIdGetResponse, UpdateWorkTypeAdminWorkTypesWorkTypeIdPatchData, UpdateWorkTypeAdminWorkTypesWorkTypeIdPatchResponse, DeleteWorkTypeAdminWorkTypesWorkTypeIdDeleteData, DeleteWorkTypeAdminWorkTypesWorkTypeIdDeleteResponse, CreateManufacturerAdminManufacturersPostData, CreateManufacturerAdminManufacturersPostResponse, ListManufacturersAdminManufacturersGetData, ListManufacturersAdminManufacturersGetResponse, GetManufacturerAdminManufacturersManufacturerIdGetData, GetManufacturerAdminManufacturersManufacturerIdGetResponse, UpdateManufacturerAdminManufacturersManufacturerIdPatchData, UpdateManufacturerAdminManufacturersManufacturerIdPatchResponse, DeleteManufacturerAdminManufacturersManufacturerIdDeleteData, DeleteManufacturerAdminManufacturersManufacturerIdDeleteResponse, ToggleOrderStatusAdminOrderOrderIdStatusPatchData, ToggleOrderStatusAdminOrderOrderIdStatusPatchResponse, LoginWorkerLoginPostData, LoginWorkerLoginPostResponse, CreateReportWorkerReportPostData, CreateReportWorkerReportPostResponse, SearchReportsWorkerReportsSearchGetData, SearchReportsWorkerReportsSearchGetResponse, GetReportWorkerReportReportIdGetData, GetReportWorkerReportReportIdGetResponse, UpdateReportWorkerReportReportIdPutData, UpdateReportWorkerReportReportIdPutResponse, DownloadPdfWorkerReportIdPdfDownloadGetData, DownloadPdfWorkerReportIdPdfDownloadGetResponse, CreateTempReportPdfWorkerReportTempPdfPostData, CreateTempReportPdfWorkerReportTempPdfPostResponse, CreateOrderWorkerOrdersPostData, CreateOrderWorkerOrdersPostResponse, SearchOrdersWorkerOrdersSearchGetData, SearchOrdersWorkerOrdersSearchGetResponse, DownloadPdfWorkerOrderIdPdfDownloadGetData, DownloadPdfWorkerOrderIdPdfDownloadGetResponse, CreateTempOrderPdfWorkerOrdersTempPdfPostData, CreateTempOrderPdfWorkerOrdersTempPdfPostResponse, CreateErrorLogWorkerErrorLogPostData, CreateErrorLogWorkerErrorLogPostResponse, GetImageUploadUrlCommonReportImageUploadUrlPostData, GetImageUploadUrlCommonReportImageUploadUrlPostResponse, DeleteFileEndpointCommonDeleteFileDeleteData, DeleteFileEndpointCommonDeleteFileDeleteResponse, GetReportPdfUrlCommonReportReportIdPdfUrlGetData, GetReportPdfUrlCommonReportReportIdPdfUrlGetResponse, GetOrderPdfUrlCommonOrderOrderIdPdfUrlGetData, GetOrderPdfUrlCommonOrderOrderIdPdfUrlGetResponse, GetSalesPersonsCommonSalesPersonsGetData, GetSalesPersonsCommonSalesPersonsGetResponse, GetSalesPersonCommonSalesPersonsSalesPersonIdGetData, GetSalesPersonCommonSalesPersonsSalesPersonIdGetResponse, GetWorkTypesCommonWorkTypesGetData, GetWorkTypesCommonWorkTypesGetResponse, GetWorkTypeCommonWorkTypesWorkTypeIdGetData, GetWorkTypeCommonWorkTypesWorkTypeIdGetResponse, GetManufacturersCommonManufacturersGetData, GetManufacturersCommonManufacturersGetResponse, GetManufacturerCommonManufacturersManufacturerIdGetData, GetManufacturerCommonManufacturersManufacturerIdGetResponse } from './types.gen';

/**
 * ユーザー登録
 * 新しいユーザーを登録します。ユーザー名、メールアドレス、およびパスワードを送信してください。登録完了後にメール認証のリンクが送信されます。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown ユーザーが正常に登録され、確認用のメールが送信されました。
 * @throws ApiError
 */
export const signUpAuthSignupPost = (data: SignUpAuthSignupPostData): CancelablePromise<SignUpAuthSignupPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/signup',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: '無効なリクエスト（例: パスワードの強度不足、既に登録済みのメールアドレス）。',
        422: 'Validation Error'
    }
}); };

/**
 * メールアドレスの確認
 * ユーザーのメールアドレスを確認します。登録時に送信された検証コードを使用してメールアドレスを検証してください。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown メールアドレスが確認されました。
 * @throws ApiError
 */
export const verifyEmailAuthVerifyEmailPost = (data: VerifyEmailAuthVerifyEmailPostData): CancelablePromise<VerifyEmailAuthVerifyEmailPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/verify-email',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: '無効なリンクまたは期限切れのリンク。',
        404: '指定されたユーザーが見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 管理者ログイン
 * 管理者ユーザーがログインIDとパスワードを使用してログインします。ログインが成功すると、認証トークンとユーザー情報が返されます。
 * @param data The data for the request.
 * @param data.formData
 * @returns LoginResponse ログイン成功
 * @throws ApiError
 */
export const signInAuthLoginPost = (data: SignInAuthLoginPostData): CancelablePromise<SignInAuthLoginPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/login',
    formData: data.formData,
    mediaType: 'application/x-www-form-urlencoded',
    errors: {
        400: 'メールアドレスまたはパスワードが正しくありません',
        401: 'アカウントが無効化されています',
        403: '管理者権限がありません',
        404: '指定されたユーザーが見つかりません',
        422: 'Validation Error'
    }
}); };

/**
 * ログアウト
 * 現在のセッションからログアウトします。アクセストークンとリフレッシュトークンが無効化されます。
 * @returns unknown ログアウト成功
 * @throws ApiError
 */
export const logoutAuthLogoutPost = (): CancelablePromise<LogoutAuthLogoutPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/logout',
    errors: {
        401: '認証エラー（無効なトークン）'
    }
}); };

/**
 * アクセストークンの更新
 * リフレッシュトークンを使用して新しいアクセストークンを取得します。
 * @returns LoginResponse トークンが正常に更新されました。
 * @throws ApiError
 */
export const refreshTokenAuthRefreshPost = (): CancelablePromise<RefreshTokenAuthRefreshPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/auth/refresh',
    errors: {
        401: '認証エラー（リフレッシュトークンが無効または期限切れ）'
    }
}); };

/**
 * ユーザーを新規作成
 * 新しいユーザーアカウントを作成します。氏名、ログインID、パスワード、権限等の基本情報が必要です。電話番号とメールアドレスは任意です。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UserResponse Successful Response
 * @throws ApiError
 */
export const createUserAdminUserPost = (data: CreateUserAdminUserPostData): CancelablePromise<CreateUserAdminUserPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/user',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザーのパスワードを変更
 * 指定されたユーザーのパスワードを変更します。
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @param data.requestBody
 * @returns UserResponse Successful Response
 * @throws ApiError
 */
export const updatePasswordAdminUsersUserIdPasswordPatch = (data: UpdatePasswordAdminUsersUserIdPasswordPatchData): CancelablePromise<UpdatePasswordAdminUsersUserIdPasswordPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/users/{user_id}/password',
    path: {
        user_id: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'パスワードの形式が不正です。',
        404: '指定されたユーザーが見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー情報を更新
 * 既存のユーザーアカウント情報を更新します。更新したいフィールドのみを送信してください。
 * @param data The data for the request.
 * @param data.userId
 * @param data.requestBody
 * @returns UserResponse Successful Response
 * @throws ApiError
 */
export const updateUserAdminUserUserIdPatch = (data: UpdateUserAdminUserUserIdPatchData): CancelablePromise<UpdateUserAdminUserUserIdPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/user/{user_id}',
    path: {
        user_id: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザーを削除
 * 指定されたユーザーを論理削除します。
 * @param data The data for the request.
 * @param data.userId
 * @returns DeleteUserResponse Successful Response
 * @throws ApiError
 */
export const deleteUserAdminUserUserIdDelete = (data: DeleteUserAdminUserUserIdDeleteData): CancelablePromise<DeleteUserAdminUserUserIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/user/{user_id}',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー一覧を取得
 * 登録されているユーザーの一覧を取得します。キーワードやロールで絞り込みが可能です。archived=trueの場合は削除済みデータを取得。
 * @param data The data for the request.
 * @param data.limit 取得件数
 * @param data.skip スキップ件数（ページネーション用）
 * @param data.keyword 検索キーワード（氏名、メールアドレス、電話番号）
 * @param data.role ユーザー権限での絞り込み
 * @param data.archived 削除済みデータを取得する場合はtrue
 * @returns UserList Successful Response
 * @throws ApiError
 */
export const listUsersAdminUsersGet = (data: ListUsersAdminUsersGetData = {}): CancelablePromise<ListUsersAdminUsersGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/users',
    query: {
        limit: data.limit,
        skip: data.skip,
        keyword: data.keyword,
        role: data.role,
        archived: data.archived
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー情報を取得
 * 指定されたIDのユーザー情報を取得します。
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns UserResponse Successful Response
 * @throws ApiError
 */
export const getUserAdminUsersUserIdGet = (data: GetUserAdminUsersUserIdGetData): CancelablePromise<GetUserAdminUsersUserIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/users/{user_id}',
    path: {
        user_id: data.userId
    },
    errors: {
        404: '指定されたユーザーが見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 削除済みユーザーを復元
 * 論理削除されたユーザーを復元します（管理者用）
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns UserResponse Successful Response
 * @throws ApiError
 */
export const restoreUserAdminUsersUserIdRestorePost = (data: RestoreUserAdminUsersUserIdRestorePostData): CancelablePromise<RestoreUserAdminUsersUserIdRestorePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/users/{user_id}/restore',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザーを完全削除
 * 論理削除済みのユーザーを完全に削除します（データベースからも削除、復元不可）
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns void Successful Response
 * @throws ApiError
 */
export const permanentlyDeleteUserAdminUsersUserIdPermanentDelete = (data: PermanentlyDeleteUserAdminUsersUserIdPermanentDeleteData): CancelablePromise<PermanentlyDeleteUserAdminUsersUserIdPermanentDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/users/{user_id}/permanent',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 企業を新規作成
 * 新しい企業アカウントを作成します。企業名、ログインID、パスワード等の基本情報が必要です。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CompanyResponse Successful Response
 * @throws ApiError
 */
export const createCompanyAdminCompanyPost = (data: CreateCompanyAdminCompanyPostData): CancelablePromise<CreateCompanyAdminCompanyPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/company',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 企業情報を取得
 * 指定されたIDの企業情報を取得します。企業が存在しない場合は404エラーを返します。
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyResponse Successful Response
 * @throws ApiError
 */
export const getCompanyAdminCompanyCompanyIdGet = (data: GetCompanyAdminCompanyCompanyIdGetData): CancelablePromise<GetCompanyAdminCompanyCompanyIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/company/{company_id}',
    path: {
        company_id: data.companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 企業情報を更新
 * 指定されたIDの企業情報を更新します。更新したい項目のみを含めることができます。企業が存在しない場合は404エラーを返します。
 * @param data The data for the request.
 * @param data.companyId
 * @param data.requestBody
 * @returns CompanyResponse Successful Response
 * @throws ApiError
 */
export const updateCompanyAdminCompanyCompanyIdPut = (data: UpdateCompanyAdminCompanyCompanyIdPutData): CancelablePromise<UpdateCompanyAdminCompanyCompanyIdPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/company/{company_id}',
    path: {
        company_id: data.companyId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 指定したreport_typeの最小限のレポート情報を検索して取得
 * report_type(1,2,3,4)に基づいて最小限の報告書情報をフィルタリングして取得します。archived=trueの場合は削除済みデータを取得。
 * @param data The data for the request.
 * @param data.reportType
 * @param data.search
 * @param data.deliveryDestination
 * @param data.address
 * @param data.workResult
 * @param data.responsiblePerson
 * @param data.workerName
 * @param data.status
 * @param data.salesStatus
 * @param data.startDate
 * @param data.endDate
 * @param data.archived 削除済みデータを取得する場合はtrue
 * @returns ReportMinimalResponse Successful Response
 * @throws ApiError
 */
export const getMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGet = (data: GetMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGetData): CancelablePromise<GetMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/reports/type/{report_type}/minimal',
    path: {
        report_type: data.reportType
    },
    query: {
        search: data.search,
        delivery_destination: data.deliveryDestination,
        address: data.address,
        work_result: data.workResult,
        responsible_person: data.responsiblePerson,
        worker_name: data.workerName,
        status: data.status,
        sales_status: data.salesStatus,
        start_date: data.startDate,
        end_date: data.endDate,
        archived: data.archived
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書詳細を取得
 * Get a specific report by ID
 * @param data The data for the request.
 * @param data.reportId
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const getReportByAdminAdminReportReportIdGet = (data: GetReportByAdminAdminReportReportIdGetData): CancelablePromise<GetReportByAdminAdminReportReportIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/report/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書を更新
 * Update an existing report
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const adminUpdateReportAdminReportReportIdPut = (data: AdminUpdateReportAdminReportReportIdPutData): CancelablePromise<AdminUpdateReportAdminReportReportIdPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/report/{report_id}',
    path: {
        report_id: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書を論理削除
 * 指定されたIDの報告書を論理削除します（データは保持されます）
 * @param data The data for the request.
 * @param data.reportId
 * @returns void Successful Response
 * @throws ApiError
 */
export const adminDeleteReportAdminReportReportIdDelete = (data: AdminDeleteReportAdminReportReportIdDeleteData): CancelablePromise<AdminDeleteReportAdminReportReportIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/report/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書のステータスを切り替え
 * Toggle the status of an existing report between UNPROCESSED and COMPLETED
 * @param data The data for the request.
 * @param data.reportId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const toggleReportStatusAdminReportReportIdStatusPatch = (data: ToggleReportStatusAdminReportReportIdStatusPatchData): CancelablePromise<ToggleReportStatusAdminReportReportIdStatusPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/report/{report_id}/status',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 営業ステータスを切り替え
 * Toggle the sales status of an existing report between UNPROCESSED and COMPLETED
 * @param data The data for the request.
 * @param data.reportId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const toggleSalesStatusAdminReportReportIdSalesStatusPatch = (data: ToggleSalesStatusAdminReportReportIdSalesStatusPatchData): CancelablePromise<ToggleSalesStatusAdminReportReportIdSalesStatusPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/report/{report_id}/sales-status',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 削除済み報告書を復元
 * 論理削除された報告書を復元します（管理者用）
 * @param data The data for the request.
 * @param data.reportId
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const restoreReportAdminReportReportIdRestorePost = (data: RestoreReportAdminReportReportIdRestorePostData): CancelablePromise<RestoreReportAdminReportReportIdRestorePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/report/{report_id}/restore',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書を完全削除
 * 論理削除済みの報告書を完全に削除します（データベースからも削除、復元不可）
 * @param data The data for the request.
 * @param data.reportId
 * @returns void Successful Response
 * @throws ApiError
 */
export const permanentlyDeleteReportAdminReportReportIdPermanentDelete = (data: PermanentlyDeleteReportAdminReportReportIdPermanentDeleteData): CancelablePromise<PermanentlyDeleteReportAdminReportReportIdPermanentDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/report/{report_id}/permanent',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エアコンExcelファイルをダウンロード
 * 指定されたIDの報告書に含まれるエアコン情報をExcelファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadExcelAdminReportIdExcelDownloadGet = (data: DownloadExcelAdminReportIdExcelDownloadGetData): CancelablePromise<DownloadExcelAdminReportIdExcelDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/report/{id}/excel-download',
    path: {
        id: data.id
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書のPDFをダウンロード
 * 指定されたIDの報告書に含まれる情報をPDFファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadPdfAdminReportIdPdfDownloadGet = (data: DownloadPdfAdminReportIdPdfDownloadGetData): CancelablePromise<DownloadPdfAdminReportIdPdfDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/report/{id}/pdf-download',
    path: {
        id: data.id
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書PDFを再生成
 * PDF未生成または破損した報告書のPDFをバックグラウンドで再生成します。完了後にpdf_urlが更新されます。
 * @param data The data for the request.
 * @param data.reportId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const regenerateReportPdfAdminReportReportIdRegeneratePdfPost = (data: RegenerateReportPdfAdminReportReportIdRegeneratePdfPostData): CancelablePromise<RegenerateReportPdfAdminReportReportIdRegeneratePdfPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/report/{report_id}/regenerate-pdf',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書のPDFをS3からダウンロード
 * S3に保存された報告書PDFファイルをダウンロードします。
 * @param data The data for the request.
 * @param data.reportId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadReportPdfFromS3AdminReportReportIdPdfDownloadS3Get = (data: DownloadReportPdfFromS3AdminReportReportIdPdfDownloadS3GetData): CancelablePromise<DownloadReportPdfFromS3AdminReportReportIdPdfDownloadS3GetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/report/{report_id}/pdf-download-s3',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書のPDFをS3からダウンロード
 * S3に保存された受注書PDFファイルをダウンロードします。
 * @param data The data for the request.
 * @param data.orderId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadOrderPdfFromS3AdminOrderOrderIdPdfDownloadS3Get = (data: DownloadOrderPdfFromS3AdminOrderOrderIdPdfDownloadS3GetData): CancelablePromise<DownloadOrderPdfFromS3AdminOrderOrderIdPdfDownloadS3GetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/order/{order_id}/pdf-download-s3',
    path: {
        order_id: data.orderId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 最小限の受注書情報を検索して取得
 * 受注書の最小限の情報をフィルタリングして取得します。archived=trueの場合は削除済みデータを取得。
 * @param data The data for the request.
 * @param data.search
 * @param data.customerName
 * @param data.address
 * @param data.creatorName
 * @param data.status
 * @param data.preferredStartDate
 * @param data.preferredEndDate
 * @param data.workStartDate
 * @param data.workEndDate
 * @param data.startDate
 * @param data.endDate
 * @param data.archived 削除済みデータを取得する場合はtrue
 * @returns OrderMinimalResponse Successful Response
 * @throws ApiError
 */
export const getMinimalOrdersAdminOrdersMinimalGet = (data: GetMinimalOrdersAdminOrdersMinimalGetData = {}): CancelablePromise<GetMinimalOrdersAdminOrdersMinimalGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/orders/minimal',
    query: {
        search: data.search,
        customer_name: data.customerName,
        address: data.address,
        creator_name: data.creatorName,
        status: data.status,
        preferred_start_date: data.preferredStartDate,
        preferred_end_date: data.preferredEndDate,
        work_start_date: data.workStartDate,
        work_end_date: data.workEndDate,
        start_date: data.startDate,
        end_date: data.endDate,
        archived: data.archived
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書を論理削除
 * 指定されたIDの受注書を論理削除します（データは保持されます）
 * @param data The data for the request.
 * @param data.orderId
 * @returns void Successful Response
 * @throws ApiError
 */
export const adminDeleteOrderAdminOrdersOrderIdDelete = (data: AdminDeleteOrderAdminOrdersOrderIdDeleteData): CancelablePromise<AdminDeleteOrderAdminOrdersOrderIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/orders/{order_id}',
    path: {
        order_id: data.orderId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書を更新
 * 指定されたIDの受注書を更新します。
 * @param data The data for the request.
 * @param data.orderId
 * @param data.requestBody
 * @returns OrderResponse Successful Response
 * @throws ApiError
 */
export const updateOrderAdminOrdersOrderIdPut = (data: UpdateOrderAdminOrdersOrderIdPutData): CancelablePromise<UpdateOrderAdminOrdersOrderIdPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/orders/{order_id}',
    path: {
        order_id: data.orderId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 削除済み受注書を復元
 * 論理削除された受注書を復元します（管理者用）
 * @param data The data for the request.
 * @param data.orderId
 * @returns OrderResponse Successful Response
 * @throws ApiError
 */
export const restoreOrderAdminOrdersOrderIdRestorePost = (data: RestoreOrderAdminOrdersOrderIdRestorePostData): CancelablePromise<RestoreOrderAdminOrdersOrderIdRestorePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/orders/{order_id}/restore',
    path: {
        order_id: data.orderId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書を完全削除
 * 論理削除済みの受注書を完全に削除します（データベースからも削除、復元不可）
 * @param data The data for the request.
 * @param data.orderId
 * @returns void Successful Response
 * @throws ApiError
 */
export const permanentlyDeleteOrderAdminOrdersOrderIdPermanentDelete = (data: PermanentlyDeleteOrderAdminOrdersOrderIdPermanentDeleteData): CancelablePromise<PermanentlyDeleteOrderAdminOrdersOrderIdPermanentDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/orders/{order_id}/permanent',
    path: {
        order_id: data.orderId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書詳細を取得
 * Get a specific order by ID
 * @param data The data for the request.
 * @param data.orderId
 * @returns OrderResponse Successful Response
 * @throws ApiError
 */
export const getOrderByIdAdminOrderOrderIdGet = (data: GetOrderByIdAdminOrderOrderIdGetData): CancelablePromise<GetOrderByIdAdminOrderOrderIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/order/{order_id}',
    path: {
        order_id: data.orderId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書Excelファイルをダウンロード
 * 指定されたIDの受注書情報をExcelファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadOrderExcelAdminOrderIdExcelDownloadGet = (data: DownloadOrderExcelAdminOrderIdExcelDownloadGetData): CancelablePromise<DownloadOrderExcelAdminOrderIdExcelDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/order/{id}/excel-download',
    path: {
        id: data.id
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書のPDFをダウンロード
 * 指定されたIDの受注書に含まれる情報をPDFファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadPdfAdminOrderIdPdfDownloadGet = (data: DownloadPdfAdminOrderIdPdfDownloadGetData): CancelablePromise<DownloadPdfAdminOrderIdPdfDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/order/{id}/pdf-download',
    path: {
        id: data.id
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 複数報告書の全画像をZIPダウンロード
 * 指定された複数報告書IDに含まれる全ての画像をZIPファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.reportIds カンマ区切りの報告書ID (例: 1,2,3)
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadMultipleReportsImagesAdminReportsImagesDownloadGet = (data: DownloadMultipleReportsImagesAdminReportsImagesDownloadGetData): CancelablePromise<DownloadMultipleReportsImagesAdminReportsImagesDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/reports/images-download',
    query: {
        report_ids: data.reportIds
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 複数受注書の全画像をZIPダウンロード
 * 指定された複数受注書IDに含まれる全ての画像をZIPファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.orderIds カンマ区切りの受注書ID (例: 1,2,3)
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadMultipleOrdersImagesAdminOrdersImagesDownloadGet = (data: DownloadMultipleOrdersImagesAdminOrdersImagesDownloadGetData): CancelablePromise<DownloadMultipleOrdersImagesAdminOrdersImagesDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/orders/images-download',
    query: {
        order_ids: data.orderIds
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 営業担当者を新規作成
 * 新しい営業担当者を作成します。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SalesPersonResponse Successful Response
 * @throws ApiError
 */
export const createSalesPersonAdminSalesPersonsPost = (data: CreateSalesPersonAdminSalesPersonsPostData): CancelablePromise<CreateSalesPersonAdminSalesPersonsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/sales-persons',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 営業担当者一覧を取得
 * 登録されている営業担当者の一覧を取得します。キーワードで絞り込みが可能です。
 * @param data The data for the request.
 * @param data.search 検索キーワード（名前）
 * @returns SalesPersonResponse Successful Response
 * @throws ApiError
 */
export const listSalesPersonsAdminSalesPersonsGet = (data: ListSalesPersonsAdminSalesPersonsGetData = {}): CancelablePromise<ListSalesPersonsAdminSalesPersonsGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/sales-persons',
    query: {
        search: data.search
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 営業担当者情報を取得
 * 指定されたIDの営業担当者情報を取得します。
 * @param data The data for the request.
 * @param data.salesPersonId 営業担当者ID
 * @returns SalesPersonResponse Successful Response
 * @throws ApiError
 */
export const getSalesPersonAdminSalesPersonsSalesPersonIdGet = (data: GetSalesPersonAdminSalesPersonsSalesPersonIdGetData): CancelablePromise<GetSalesPersonAdminSalesPersonsSalesPersonIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/sales-persons/{sales_person_id}',
    path: {
        sales_person_id: data.salesPersonId
    },
    errors: {
        404: '指定された営業担当者が見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 営業担当者情報を更新
 * 既存の営業担当者情報を更新します。更新したいフィールドのみを送信してください。
 * @param data The data for the request.
 * @param data.salesPersonId 営業担当者ID
 * @param data.requestBody
 * @returns SalesPersonResponse Successful Response
 * @throws ApiError
 */
export const updateSalesPersonAdminSalesPersonsSalesPersonIdPatch = (data: UpdateSalesPersonAdminSalesPersonsSalesPersonIdPatchData): CancelablePromise<UpdateSalesPersonAdminSalesPersonsSalesPersonIdPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/sales-persons/{sales_person_id}',
    path: {
        sales_person_id: data.salesPersonId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 営業担当者を削除
 * 指定された営業担当者を論理削除します。
 * @param data The data for the request.
 * @param data.salesPersonId 営業担当者ID
 * @returns void Successful Response
 * @throws ApiError
 */
export const deleteSalesPersonAdminSalesPersonsSalesPersonIdDelete = (data: DeleteSalesPersonAdminSalesPersonsSalesPersonIdDeleteData): CancelablePromise<DeleteSalesPersonAdminSalesPersonsSalesPersonIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/sales-persons/{sales_person_id}',
    path: {
        sales_person_id: data.salesPersonId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 作業種別を新規作成
 * 新しい作業種別を作成します。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns WorkTypeResponse Successful Response
 * @throws ApiError
 */
export const createWorkTypeAdminWorkTypesPost = (data: CreateWorkTypeAdminWorkTypesPostData): CancelablePromise<CreateWorkTypeAdminWorkTypesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/work-types',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 作業種別一覧を取得
 * 登録されている作業種別の一覧を取得します。キーワードで絞り込みが可能です。
 * @param data The data for the request.
 * @param data.search 検索キーワード（名前）
 * @returns WorkTypeResponse Successful Response
 * @throws ApiError
 */
export const listWorkTypesAdminWorkTypesGet = (data: ListWorkTypesAdminWorkTypesGetData = {}): CancelablePromise<ListWorkTypesAdminWorkTypesGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/work-types',
    query: {
        search: data.search
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 作業種別情報を取得
 * 指定されたIDの作業種別情報を取得します。
 * @param data The data for the request.
 * @param data.workTypeId 作業種別ID
 * @returns WorkTypeResponse Successful Response
 * @throws ApiError
 */
export const getWorkTypeAdminWorkTypesWorkTypeIdGet = (data: GetWorkTypeAdminWorkTypesWorkTypeIdGetData): CancelablePromise<GetWorkTypeAdminWorkTypesWorkTypeIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/work-types/{work_type_id}',
    path: {
        work_type_id: data.workTypeId
    },
    errors: {
        404: '指定された作業種別が見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 作業種別情報を更新
 * 既存の作業種別情報を更新します。更新したいフィールドのみを送信してください。
 * @param data The data for the request.
 * @param data.workTypeId 作業種別ID
 * @param data.requestBody
 * @returns WorkTypeResponse Successful Response
 * @throws ApiError
 */
export const updateWorkTypeAdminWorkTypesWorkTypeIdPatch = (data: UpdateWorkTypeAdminWorkTypesWorkTypeIdPatchData): CancelablePromise<UpdateWorkTypeAdminWorkTypesWorkTypeIdPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/work-types/{work_type_id}',
    path: {
        work_type_id: data.workTypeId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 作業種別を削除
 * 指定された作業種別を論理削除します。
 * @param data The data for the request.
 * @param data.workTypeId 作業種別ID
 * @returns void Successful Response
 * @throws ApiError
 */
export const deleteWorkTypeAdminWorkTypesWorkTypeIdDelete = (data: DeleteWorkTypeAdminWorkTypesWorkTypeIdDeleteData): CancelablePromise<DeleteWorkTypeAdminWorkTypesWorkTypeIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/work-types/{work_type_id}',
    path: {
        work_type_id: data.workTypeId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 製造メーカーを新規作成
 * 新しい製造メーカーを作成します。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ManufacturerResponse Successful Response
 * @throws ApiError
 */
export const createManufacturerAdminManufacturersPost = (data: CreateManufacturerAdminManufacturersPostData): CancelablePromise<CreateManufacturerAdminManufacturersPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/manufacturers',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 製造メーカー一覧を取得
 * 登録されている製造メーカーの一覧を取得します。キーワードで絞り込みが可能です。
 * @param data The data for the request.
 * @param data.search 検索キーワード（名前）
 * @returns ManufacturerResponse Successful Response
 * @throws ApiError
 */
export const listManufacturersAdminManufacturersGet = (data: ListManufacturersAdminManufacturersGetData = {}): CancelablePromise<ListManufacturersAdminManufacturersGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/manufacturers',
    query: {
        search: data.search
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 製造メーカー情報を取得
 * 指定されたIDの製造メーカー情報を取得します。
 * @param data The data for the request.
 * @param data.manufacturerId 製造メーカーID
 * @returns ManufacturerResponse Successful Response
 * @throws ApiError
 */
export const getManufacturerAdminManufacturersManufacturerIdGet = (data: GetManufacturerAdminManufacturersManufacturerIdGetData): CancelablePromise<GetManufacturerAdminManufacturersManufacturerIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/manufacturers/{manufacturer_id}',
    path: {
        manufacturer_id: data.manufacturerId
    },
    errors: {
        404: '指定された製造メーカーが見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 製造メーカー情報を更新
 * 既存の製造メーカー情報を更新します。更新したいフィールドのみを送信してください。
 * @param data The data for the request.
 * @param data.manufacturerId 製造メーカーID
 * @param data.requestBody
 * @returns ManufacturerResponse Successful Response
 * @throws ApiError
 */
export const updateManufacturerAdminManufacturersManufacturerIdPatch = (data: UpdateManufacturerAdminManufacturersManufacturerIdPatchData): CancelablePromise<UpdateManufacturerAdminManufacturersManufacturerIdPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/manufacturers/{manufacturer_id}',
    path: {
        manufacturer_id: data.manufacturerId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 製造メーカーを削除
 * 指定された製造メーカーを論理削除します。
 * @param data The data for the request.
 * @param data.manufacturerId 製造メーカーID
 * @returns void Successful Response
 * @throws ApiError
 */
export const deleteManufacturerAdminManufacturersManufacturerIdDelete = (data: DeleteManufacturerAdminManufacturersManufacturerIdDeleteData): CancelablePromise<DeleteManufacturerAdminManufacturersManufacturerIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/manufacturers/{manufacturer_id}',
    path: {
        manufacturer_id: data.manufacturerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書のステータスを切り替え
 * Toggle the status of an existing order between UNPROCESSED and COMPLETED
 * @param data The data for the request.
 * @param data.orderId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const toggleOrderStatusAdminOrderOrderIdStatusPatch = (data: ToggleOrderStatusAdminOrderOrderIdStatusPatchData): CancelablePromise<ToggleOrderStatusAdminOrderOrderIdStatusPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/order/{order_id}/status',
    path: {
        order_id: data.orderId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 作業者ログイン認証
 * ログインIDとパスワードで認証を行い、アクセストークンとユーザー情報を返却します。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns WorkerLoginResponse Successful Response
 * @throws ApiError
 */
export const loginWorkerLoginPost = (data: LoginWorkerLoginPostData): CancelablePromise<LoginWorkerLoginPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/worker/login',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        401: '認証に失敗しました。',
        404: 'ユーザーが見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 報告書を作成
 * 新しい報告書を作成します。PDFはバックグラウンドで生成されます。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ReportCreateResponse Successful Response
 * @throws ApiError
 */
export const createReportWorkerReportPost = (data: CreateReportWorkerReportPostData): CancelablePromise<CreateReportWorkerReportPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/worker/report',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書の検索
 * 企業IDと報告書タイプ、検索キーワードに基づいて報告書を検索します
 * @param data The data for the request.
 * @param data.userId
 * @param data.reportType
 * @param data.searchQuery
 * @returns SimpleReportResponse Successful Response
 * @throws ApiError
 */
export const searchReportsWorkerReportsSearchGet = (data: SearchReportsWorkerReportsSearchGetData): CancelablePromise<SearchReportsWorkerReportsSearchGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/worker/reports/search',
    query: {
        user_id: data.userId,
        report_type: data.reportType,
        search_query: data.searchQuery
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書詳細を取得
 * Get a specific report by ID
 * @param data The data for the request.
 * @param data.reportId
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const getReportWorkerReportReportIdGet = (data: GetReportWorkerReportReportIdGetData): CancelablePromise<GetReportWorkerReportReportIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/worker/report/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書を更新
 * Update an existing report
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const updateReportWorkerReportReportIdPut = (data: UpdateReportWorkerReportReportIdPutData): CancelablePromise<UpdateReportWorkerReportReportIdPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/worker/report/{report_id}',
    path: {
        report_id: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書のPDFをダウンロード
 * 指定されたIDの報告書に含まれる情報をPDFファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadPdfWorkerReportIdPdfDownloadGet = (data: DownloadPdfWorkerReportIdPdfDownloadGetData): CancelablePromise<DownloadPdfWorkerReportIdPdfDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/worker/report/{id}/pdf-download',
    path: {
        id: data.id
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書データから一時的なPDFを生成
 * ReportTempCreateRequestから直接PDFファイルを生成して返します（DBには保存しません）
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createTempReportPdfWorkerReportTempPdfPost = (data: CreateTempReportPdfWorkerReportTempPdfPostData): CancelablePromise<CreateTempReportPdfWorkerReportTempPdfPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/worker/report/temp-pdf',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書を作成
 * Create a new order with all related data
 * @param data The data for the request.
 * @param data.requestBody
 * @returns OrderCreateResponse Successful Response
 * @throws ApiError
 */
export const createOrderWorkerOrdersPost = (data: CreateOrderWorkerOrdersPostData): CancelablePromise<CreateOrderWorkerOrdersPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/worker/orders',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書の検索
 * 企業IDと各種検索条件に基づいて受注書を検索します
 * @param data The data for the request.
 * @param data.userId
 * @param data.searchQuery
 * @returns SimpleOrderResponse Successful Response
 * @throws ApiError
 */
export const searchOrdersWorkerOrdersSearchGet = (data: SearchOrdersWorkerOrdersSearchGetData): CancelablePromise<SearchOrdersWorkerOrdersSearchGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/worker/orders/search',
    query: {
        user_id: data.userId,
        search_query: data.searchQuery
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書のPDFをダウンロード
 * 指定されたIDの受注書に含まれる情報をPDFファイルとしてダウンロードします。
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadPdfWorkerOrderIdPdfDownloadGet = (data: DownloadPdfWorkerOrderIdPdfDownloadGetData): CancelablePromise<DownloadPdfWorkerOrderIdPdfDownloadGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/worker/order/{id}/pdf-download',
    path: {
        id: data.id
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書データから一時的なPDFを生成
 * OrderTempCreateRequestから直接PDFファイルを生成して返します（DBには保存しません）
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createTempOrderPdfWorkerOrdersTempPdfPost = (data: CreateTempOrderPdfWorkerOrdersTempPdfPostData): CancelablePromise<CreateTempOrderPdfWorkerOrdersTempPdfPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/worker/orders/temp-pdf',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エラーログを作成
 * 新しいエラーログを作成します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ErrorLogCreateResponse Successful Response
 * @throws ApiError
 */
export const createErrorLogWorkerErrorLogPost = (data: CreateErrorLogWorkerErrorLogPostData): CancelablePromise<CreateErrorLogWorkerErrorLogPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/worker/error-log',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 画像アップロード用の署名付きURLを取得
 * 画像アップロード用の署名付きURLを取得します。アップロードするファイル名と任意でフォルダ名を指定してください。
 * @param data The data for the request.
 * @param data.filename
 * @param data.folder
 * @returns ImageUploadUrlResponse Successful Response
 * @throws ApiError
 */
export const getImageUploadUrlCommonReportImageUploadUrlPost = (data: GetImageUploadUrlCommonReportImageUploadUrlPostData): CancelablePromise<GetImageUploadUrlCommonReportImageUploadUrlPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/common/report/image-upload-url',
    query: {
        filename: data.filename,
        folder: data.folder
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ファイルを削除
 * S3バケットからファイルを削除します
 * @param data The data for the request.
 * @param data.fileUrl
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteFileEndpointCommonDeleteFileDelete = (data: DeleteFileEndpointCommonDeleteFileDeleteData): CancelablePromise<DeleteFileEndpointCommonDeleteFileDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/common/delete-file',
    query: {
        file_url: data.fileUrl
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 報告書のPDF URLを取得
 * 指定されたIDの報告書のPDF URL情報を取得します
 * @param data The data for the request.
 * @param data.reportId
 * @returns ReportPdfUrlResponse Successful Response
 * @throws ApiError
 */
export const getReportPdfUrlCommonReportReportIdPdfUrlGet = (data: GetReportPdfUrlCommonReportReportIdPdfUrlGetData): CancelablePromise<GetReportPdfUrlCommonReportReportIdPdfUrlGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/report/{report_id}/pdf-url',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 受注書のPDF URLを取得
 * 指定されたIDの受注書のPDF URL情報を取得します
 * @param data The data for the request.
 * @param data.orderId
 * @returns OrderPdfUrlResponse Successful Response
 * @throws ApiError
 */
export const getOrderPdfUrlCommonOrderOrderIdPdfUrlGet = (data: GetOrderPdfUrlCommonOrderOrderIdPdfUrlGetData): CancelablePromise<GetOrderPdfUrlCommonOrderOrderIdPdfUrlGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/order/{order_id}/pdf-url',
    path: {
        order_id: data.orderId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 営業担当者一覧を取得
 * 営業担当者の一覧を取得します。検索やフィルタリングが可能です。
 * @param data The data for the request.
 * @param data.skip スキップする件数
 * @param data.limit 取得する件数
 * @param data.search 検索キーワード（名前）
 * @returns SalesPersonResponse Successful Response
 * @throws ApiError
 */
export const getSalesPersonsCommonSalesPersonsGet = (data: GetSalesPersonsCommonSalesPersonsGetData = {}): CancelablePromise<GetSalesPersonsCommonSalesPersonsGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/sales-persons',
    query: {
        skip: data.skip,
        limit: data.limit,
        search: data.search
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 営業担当者詳細を取得
 * 指定されたIDの営業担当者情報を取得します。
 * @param data The data for the request.
 * @param data.salesPersonId
 * @returns SalesPersonResponse Successful Response
 * @throws ApiError
 */
export const getSalesPersonCommonSalesPersonsSalesPersonIdGet = (data: GetSalesPersonCommonSalesPersonsSalesPersonIdGetData): CancelablePromise<GetSalesPersonCommonSalesPersonsSalesPersonIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/sales-persons/{sales_person_id}',
    path: {
        sales_person_id: data.salesPersonId
    },
    errors: {
        404: '指定された営業担当者が見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 作業種別一覧を取得
 * 作業種別の一覧を取得します。検索やフィルタリングが可能です。
 * @param data The data for the request.
 * @param data.skip スキップする件数
 * @param data.limit 取得する件数
 * @param data.search 検索キーワード（名前）
 * @returns WorkTypeResponse Successful Response
 * @throws ApiError
 */
export const getWorkTypesCommonWorkTypesGet = (data: GetWorkTypesCommonWorkTypesGetData = {}): CancelablePromise<GetWorkTypesCommonWorkTypesGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/work-types',
    query: {
        skip: data.skip,
        limit: data.limit,
        search: data.search
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 作業種別詳細を取得
 * 指定されたIDの作業種別情報を取得します。
 * @param data The data for the request.
 * @param data.workTypeId
 * @returns WorkTypeResponse Successful Response
 * @throws ApiError
 */
export const getWorkTypeCommonWorkTypesWorkTypeIdGet = (data: GetWorkTypeCommonWorkTypesWorkTypeIdGetData): CancelablePromise<GetWorkTypeCommonWorkTypesWorkTypeIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/work-types/{work_type_id}',
    path: {
        work_type_id: data.workTypeId
    },
    errors: {
        404: '指定された作業種別が見つかりません。',
        422: 'Validation Error'
    }
}); };

/**
 * 製造メーカー一覧を取得
 * 製造メーカーの一覧を取得します。検索やフィルタリングが可能です。
 * @param data The data for the request.
 * @param data.skip スキップする件数
 * @param data.limit 取得する件数
 * @param data.search 検索キーワード（名前）
 * @returns ManufacturerResponse Successful Response
 * @throws ApiError
 */
export const getManufacturersCommonManufacturersGet = (data: GetManufacturersCommonManufacturersGetData = {}): CancelablePromise<GetManufacturersCommonManufacturersGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/manufacturers',
    query: {
        skip: data.skip,
        limit: data.limit,
        search: data.search
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 製造メーカー詳細を取得
 * 指定されたIDの製造メーカー情報を取得します。
 * @param data The data for the request.
 * @param data.manufacturerId
 * @returns ManufacturerResponse Successful Response
 * @throws ApiError
 */
export const getManufacturerCommonManufacturersManufacturerIdGet = (data: GetManufacturerCommonManufacturersManufacturerIdGetData): CancelablePromise<GetManufacturerCommonManufacturersManufacturerIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/manufacturers/{manufacturer_id}',
    path: {
        manufacturer_id: data.manufacturerId
    },
    errors: {
        404: '指定された製造メーカーが見つかりません。',
        422: 'Validation Error'
    }
}); };